var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgForgot = function SvgForgot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 101,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.327 72.2a3.945 3.945 0 100-7.892 3.945 3.945 0 000 7.891z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.692 44.257l-.275.961.275-.96c-.691-.199-1.506-.282-2.455-.282H16.425c-4.903 0-8.89 3.988-8.89 8.891v32.352c0 4.903 3.987 8.89 8.89 8.89h49.119a2.946 2.946 0 010 5.891h-49.12c-8.149 0-14.78-6.632-14.78-14.781V52.867c0-8.15 6.631-14.781 14.78-14.781h5.728V23.172C22.152 10.967 32.303 1 44.824 1c12.52 0 22.672 9.967 22.672 22.172v14.914h5.741c1.572 0 2.9.17 4.077.508a2.946 2.946 0 01-1.622 5.663zm-15.087-6.171h1V23.172c0-9.009-7.558-16.281-16.781-16.281-9.224 0-16.781 7.272-16.781 16.281v14.914h32.562z",
    fill: "#fff",
    stroke: "#1F313A",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.532 72.2a3.945 3.945 0 100-7.891 3.945 3.945 0 000 7.89z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.353 65.348V65.377l.003.12v0a12.998 12.998 0 01-7.907 11.975h0c-1.333.569-2.16 1.899-2.16 3.349v3.411a2.945 2.945 0 11-5.891 0V80.82c0-3.843 2.257-7.28 5.738-8.766a7.118 7.118 0 004.328-6.433v-.045-.079a7.127 7.127 0 00-7.121-7.12 7.127 7.127 0 00-7.12 7.12 2.945 2.945 0 11-5.891 0c0-7.173 5.838-13.01 13.01-13.01 7.124 0 12.93 5.756 13.01 12.86zM84.27 97.055a2.945 2.945 0 11-5.89 0 2.945 2.945 0 015.89 0z",
    fill: "#fff",
    stroke: "#1F313A",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.737 72.2a3.945 3.945 0 100-7.891 3.945 3.945 0 000 7.89z",
    fill: "#fff"
  })));
};

export default SvgForgot;